import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class KidsScene extends MinigameScene {
    //Images
    private mamice : Phaser.GameObjects.Image[] = [];    
    private clicker !: Phaser.GameObjects.Image;
    private swing !: Phaser.GameObjects.Image;
    private audio !: Phaser.Sound.BaseSound;


    //values
    private clickableWidth = 100;
    private missTimePunishment = 500;
    private clickerSwingTime = 1500; //in ms

    private swingStartX = 277;
    private swingEndX = 807;

    private babies = [
        CONST.BIRTH.BABY,
        CONST.KIDS.BABY_2,
        CONST.KIDS.BABY_3,
        CONST.KIDS.BABY_4,
        CONST.KIDS.BABY_3,
    ];

    private textNames = [
        {name: CONST.KIDS.TEXT_1, x: 630},
        {name: CONST.KIDS.TEXT_2, x: 682},
        {name: CONST.KIDS.TEXT_3, x: 625},
        {name: CONST.KIDS.TEXT_4, x: 464},
        {name: CONST.KIDS.TEXT_5, x: 697},
    ]

    //logic vars
    private clickerMovingRight !: boolean;
    private swingTimer !: number;
    private hits !: number;
    private texts !: Phaser.GameObjects.Image[];


    constructor(){
        super ({
            sceneName: CONST.SCENES.KIDS,
            duration: 20000,
            startScreenColor: 0xC1FFDB,
            startText: "GET\nKIDS!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: CONST.KIDS.END,
            nextScene: CONST.SCENES.MIDLIFE,
            endButtons: {
                normalNoSkip: {x: 426.5, y: 394, scale: 1.25},
                normalWithSkip: {x: 283, y: 394, scale: 1.25},
                skip: {x: 570, y: 394, scale: 1.25}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.clickerMovingRight = true;
        this.swingTimer = 0;
        this.hits = 0;
        this.mamice = [];
        this.texts = [];
    }

    _preload(){
    }

    _create(){
        let background = this.add.image(0,0, CONST.BIRTH.BACKGROUND).setOrigin(0, 0);
        background.setInteractive();
        background.on("pointerdown", ()=>{
            this.handleClick();
        })

        this.add.image(145, 433, CONST.BIRTH.PUSH);
        this.add.image(717, 262, CONST.BIRTH.STROLLER).setDepth(100);
        this.swing = this.add.image(542, 429, CONST.BIRTH.SWING);
        this.clicker = this.add.image(542, 429, CONST.BIRTH.CLICKER);

        this.add.image(156, 272.5, CONST.KIDS.DADBOD).setDepth(110).setScale(1, 1.437);;
        this.addAnimation(CONST.KIDS.DADHEAD, CONST.ANIMATIONS.DADHEAD, 60)
                .setDepth(111)
                .setLoop(true)
                .setOffset(0, -185)
                .start();

        this.createMamice(226, 299);
        this.setMamicaState(this.hits);

        this.createTexts();

        this.audio = this.sound.add(CONST.AUDIO.CRY, {
            loop: false
        });
    }

    private createMamice(x: number, y: number){
        var mamicePaths = [CONST.KIDS.MAMICA1, CONST.KIDS.MAMICA2, CONST.KIDS.MAMICA3, CONST.KIDS.MAMICA4, CONST.KIDS.MAMICA5];
        mamicePaths.forEach(path => {
            this.mamice.push(this.add.image(x, y, path).setVisible(false).setDepth(150));
        });
    }

    private createTexts(){
        this.textNames.forEach(textName => {
           var text = this.add.image(textName.x, 58, textName.name).setDepth(20).setVisible(false);
           this.texts.push(text);
        });
    }

    private handleClick(){
        if (this.isCurrentState(CONST.GAMESTATE.PLAYING)){
            if (this.isClickerWithinLimits()){
                this.hits++;
                this.playBabyAnimation(this.hits);
                this.showText(this.hits);
                this.setMamicaState(this.hits);
                this.playAudio();
            } else {
                this.changeGameplayTimerDuration(-this.missTimePunishment);
                this.cameras.main.flash(200, 255, 64, 43);
            }
        }
    }

    private playBabyAnimation(hits: number){
        if (hits <= this.babies.length){
            this.addAnimation(this.babies[hits-1], CONST.ANIMATIONS.KIDSSHOOTBABY, 60)
                .setScaleMultiplier(0.65)
                .setDepth(90)
                .setLoop(false)
                .start();
        }
    }

    private playAudio(){
        this.audio.play();
    }

    private showText(hits: number){
        if (hits <= this.texts.length){
            this.texts.forEach(text => { text.setVisible(false)})
            this.texts[hits-1].setVisible(true);
        }
    }

    private isClickerWithinLimits() : boolean{
        return Phaser.Math.Difference(this.clicker.x, this.swing.x) < this.clickableWidth;
    }

    private setMamicaState(index: number){
        if (index >= this.mamice.length){
            this.triggerWin();
            return;
        }

        for (var i = 0; i < this.mamice.length; i++){
           this.mamice[i].setVisible(i===index);
        }
    }


    _update(time: number, delta: number){
        if (this.isCurrentState(CONST.GAMESTATE.PLAYING)) {
            this.moveClicker(delta);
        }
    }

    private moveClicker(delta: number){
        if (this.clickerMovingRight){
            this.swingTimer += delta / this.clickerSwingTime;

            if (this.swingTimer >= 1){
                this.clickerMovingRight = !this.clickerMovingRight;
                this.swingTimer = 1;
            }
        } else {
            this.swingTimer -= delta / this.clickerSwingTime;

            if (this.swingTimer <= 0){
                this.clickerMovingRight = !this.clickerMovingRight;
                this.swingTimer = 0;
            }
        }
        this.clicker.x = Phaser.Math.Interpolation.SmoothStep(this.swingTimer, this.swingStartX, this.swingEndX);
}

    _timeout(){
        this.triggerLoss();
    }

    _afterLoss(){
        this.audio.stop();
    }

    _afterWin(){
        this.audio.stop();
    }

    private triggerWin(){
        //trigger win after 1 second and load next scene
        this.winGame(1500);
    }

    private triggerLoss(){
        this.loseGame();
    }
}